import { Spinner } from 'react-bootstrap';
import TableComponent from '../../../../../components/table/TableComponent';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAlert } from 'react-alert';
import { useOnMount } from '../../../../../components/common/Hooks';
import { useDispatch, useSelector } from 'react-redux';
import { setDirection, setPage, setSortField } from '../../../../../redux/slices/PaginationSlice';
import { isMobile } from 'react-device-detect';
import { ConsumedProductsFilter } from './ConsumedProductsFilter';
import './ConsumedProducts.css';
import { getMonthStart, getTodayDate } from '../../../../../utils/TimeUtils';
import { getConsumedProductsReport } from '../ReportsService';

export const ConsumedProductsPage = () => {

    const { t, i18n } = useTranslation();
    const alert = useAlert();
    const onMount = useOnMount();
    const [loading, setLoading] = useState(true);
    const dispatch = useDispatch();
    const pagination = useSelector((state) => state.pagination);
    const [data, setData] = useState([]);
    const [filterValue, setFilterValue] = useState({
        from: getMonthStart(),
        till: getTodayDate(),
    });

    useEffect(() => {
        if (onMount) {
            init();
        } else {
            load();
        }
    }, [pagination.page, pagination.sortByField, pagination.sortingDirection]);

    const init = () => {
        if (pagination.sortByField === 'productTitle'
            && pagination.page === 0
            && pagination.sortingDirection === 'ASC') {
            load();
        } else {
            dispatch(setSortField('productTitle'));
            dispatch(setPage(0));
            dispatch(setDirection('ASC'));
        }
    };

    const load = () => {
        let request = {
            page: pagination.page,
            size: pagination.size,
            ascDesc: pagination.sortingDirection,
            sortField: pagination.sortByField,
            lang: i18n.language.toUpperCase(),
            from: filterValue.from,
            till: filterValue.till,
        };
        getConsumedProductsReport(request)
            .then((response) => {
                setData(response.data);
            })
            .catch(() => alert.error(t('alert:loadingError')))
            .finally(() => setLoading(false));
    };

    return (
        <div className={'consumed-products'}>
            <div className={isMobile ? 'mobile-filter-container' : 'filter-container'}>
                <ConsumedProductsFilter filter={filterValue} doFilter={load}></ConsumedProductsFilter>
            </div>
            {loading ? (
                <Spinner animation='border' className='container' />
            ) : (<TableComponent
                model={{
                    productTitle: '',
                    received: '',
                    consumed: '',
                    current: '',
                    price: '',
                }}
                translationsGroup='reports:consumedProducts.'
                columnsNames={[
                    'productTitle',
                    'received',
                    'consumed',
                    'current',
                    'price',
                ]}
                totalElements={data.totalElements}
                contents={data.content}>
            </TableComponent>)}
        </div>
    );
};